import { defMathOp } from "./compile/emit.js";
const [sub, sub2, sub3, sub4] = defMathOp("-");
export {
  sub,
  sub2,
  sub3,
  sub4
};
